// extracted by mini-css-extract-plugin
export default {"chip":"IssuePullRequestStatusLabel_chip__BW+Ey"};